export function applyTheme(tokens: Record<string, string> | undefined): void {
  if (typeof document === 'undefined' || !tokens) {
    return;
  }

  const root = document.documentElement;
  Object.entries(tokens).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}
